import React from 'react';
import { AddUniversal } from '@duxton-web/icons';
import { Button } from '@duxton-web/ui';
import { useParams } from 'react-router-dom';

import { isViewMode } from '../../constants';
import { useExperimentDispatchContext } from '../../contexts/experiment-context';
import { addConfiguration } from '../../store/actions/experiment/action-creators';

const AddConfiguration = () => {
  const params = useParams<{ action: string }>();
  const action = params.action;
  const disabled = isViewMode(action);

  const experimentDispatch = useExperimentDispatchContext();

  if (disabled) return null;

  return (
    <Button
      type="secondary"
      size="small"
      icon={<AddUniversal />}
      onClick={() => experimentDispatch(addConfiguration())}
    >
      Add countries with different variable values
    </Button>
  );
};

export default AddConfiguration;
